
import React from 'react'

import checkedImg from './images/check_box_black.svg';
import checkImg from './images/check_box_outline_blank_black.svg';

import  './styles/CheckBox.scss'

const CheckBox = (props) => {
  let check = props.on? checkedImg : checkImg;

  return <span className="md-checkbox" onClick={props.onClick}>
    <img src={check} alt="Checkbox" /> {props.label}  {props.adminNote == null ? "" : <span className="adminNote">({props.adminNote})</span>}
      </span>
}

export default CheckBox;



// WEBPACK FOOTER //
// ./src/components/ui/CheckBox.jsx